import styled from "styled-components";

export const InquirySideMenu = styled.section`
  width: 100vw;
  display: flex;
  min-height: calc(100vh - 56px);
  background: ${(props) => props.theme.colors.white100};
  flex-direction: column;
`;
